import { computed } from 'vue';
import { useStore } from 'vuex';
import { createAiChatServiceAuth } from '@/v3/app/ai/AiChatServiceAuth';
import { createAiChatServiceDMZ } from '@/v3/app/ai/AiChatServiceDMZ';

export function useAiChatService() {
  const store = useStore();
  
  // Use domain to decide if authenticated
  const domain = computed(() => store.getters.domain);
  
  // Create instances
  const authService = createAiChatServiceAuth(domain);
  const dmzService = createAiChatServiceDMZ(store);

  // Return a proxy that automatically routes to the right service
  return {
    async sendPrompt(params, onMessageReceived, onError, onFinished) {
      if (domain.value) {
        return authService.sendPrompt(params, onMessageReceived, onError, onFinished);
      } else {
        return dmzService.sendPrompt(params, onMessageReceived, onError, onFinished);
      }
    },
    
    async savePrompt(messageId, likedValue) {
      if (domain.value) {
        return authService.savePrompt(messageId, likedValue);
      } else {
        return dmzService.savePrompt(messageId, likedValue);
      }
    }
  };
}
